import React, { Fragment } from 'react';
import MetaBar from './metabar';
import _filter from 'lodash/filter';
import { CYOA_NETWORK_IDS } from '../../config';



const MastHead = (props) => {
  
  const HAS_CYOA = (_filter(props.bookingGroup.trips, (o) => {return o.tour_id === CYOA_NETWORK_IDS["europe"].id || o.tour_id === CYOA_NETWORK_IDS["usa"].id}).length > 0) ? true : false;

  if(Object.keys(props.bookingGroup).length === 0){
    return null;
  }
  else{
    return (
      <Fragment>
      <MetaBar currencyCode={props.currencyCode}/>
      <div className="masthead">

        <div className="masthead-background"></div>

        <div className="masthead-text">
          <div className="row">
            <div className="columns small-12 large-11 large-offset-0-5">

              <p className="congrats-text margin-b-30">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" style={{'height': '66px', 'width': '66px', 'fill': '#FFFFFF', 'display': 'block', 'margin':'auto auto 20px auto' }}>
                      <path d="M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 464c-118.664 0-216-96.055-216-216 0-118.663 96.055-216 216-216 118.664 0 216 96.055 216 216 0 118.663-96.055 216-216 216zm141.63-274.961L217.15 376.071c-4.705 4.667-12.303 4.637-16.97-.068l-85.878-86.572c-4.667-4.705-4.637-12.303.068-16.97l8.52-8.451c4.705-4.667 12.303-4.637 16.97.068l68.976 69.533 163.441-162.13c4.705-4.667 12.303-4.637 16.97.068l8.451 8.52c4.668 4.705 4.637 12.303-.068 16.97z"/>
                  </svg>
                  Congratulations <span className="bold"> { props.firstName }! </span>
              </p>
              <p className="no-margin">Thanks for reserving a trip with Busabout.</p>
              <p className="margin-b-40">Your booking reference number is <span className="bold">{props.bookingId}</span></p>

              <a
              href={`${process.env.REACT_APP_WWW_BUILDER_URL}/itinerary?id=${props.bookingGroup.cyoa_token}`}
              target="_blank"
              rel="noopener noreferrer"
              style={{display: HAS_CYOA ? "line-block" : "none"}}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path d="M576 56.015v335.97a23.998 23.998 0 0 1-13.267 21.466l-128 64C418.948 485.344 400 473.992 400 455.985v-335.97a23.998 23.998 0 0 1 13.267-21.466l128-64C557.052 26.656 576 38.008 576 56.015zm-206.253 42.07l-144-64c-15.751-7-33.747 4.461-33.747 21.932v335.967a24 24 0 0 0 14.253 21.931l144 64c15.751 7 33.747-4.461 33.747-21.931V120.017a24 24 0 0 0-14.253-21.932zm-228.48-63.536l-128 63.985A23.998 23.998 0 0 0 0 120v335.985c0 18.007 18.948 29.359 34.733 21.466l128-63.985A23.998 23.998 0 0 0 176 392V56.015c0-18.007-18.948-29.359-34.733-21.466z"/></svg>
                View Itinerary
              </a>

              <a 
              href={`https://manage.busabout.com/Register?client_ref=${props.bookingGroup.group_booking_id}&first_name=${props.bookingGroup.passengers[0].first_name}&family_name=${props.bookingGroup.passengers[0].family_name}` } 
              target="_blank" 
              rel="noopener noreferrer"
              style={{display: !HAS_CYOA ? "line-block" : "none"}}>
                My Trip
              </a>

            </div>
          </div>
        </div>

      <div className="paint-stroke">
        <img src="https://images.contentful.com/3ng3kfj0qs70/58izAOMgU0qsuIey6U60Ig/4c9b82c441a831529869cb571817a450/paintstroke.svg" alt="" />
      </div>

      </div>
      </Fragment>

    )
  }

}

export default React.memo(MastHead);


// WEBPACK FOOTER //
// ./src/components/shared/masthead.js